import { TCellComponent } from '../List';
import { Icon } from '@plone/volto/components';
import verifiedSVG from '../../../../icons/verifiziert.svg';

const VerifiedCellContent: TCellComponent = ({ listId }) =>
  listId === 'verified' ? (
    <Icon className={'verified-icon'} name={verifiedSVG} size={'25px'} />
  ) : null;

export default VerifiedCellContent;
